import React from 'react';
import type { ISnapIcon } from '../icons-mapper';

export const Archive = (props: ISnapIcon) => {
  const { size, title, color = 'currentColor' } = props;
  return (
    <svg
      height={size}
      width={size}
      viewBox='0 0 20 20'
      fill={color}
      xmlns='http://www.w3.org/2000/svg'
    >
      <title>{title}</title>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2 7.5H18L17.189 15.21C17.1371 15.7015 16.905 16.1564 16.5376 16.487C16.1701 16.8175 15.6933 17.0003 15.199 17H4.802C4.30774 17.0003 3.8309 16.8175 3.46343 16.487C3.09596 16.1564 2.8639 15.7015 2.812 15.21L2 7.5ZM7 11C7 10.7348 7.10536 10.4804 7.29289 10.2929C7.48043 10.1054 7.73478 10 8 10H12C12.2652 10 12.5196 10.1054 12.7071 10.2929C12.8946 10.4804 13 10.7348 13 11C13 11.2652 12.8946 11.5196 12.7071 11.7071C12.5196 11.8946 12.2652 12 12 12H8C7.73478 12 7.48043 11.8946 7.29289 11.7071C7.10536 11.5196 7 11.2652 7 11Z'
      />
    </svg>
  );
};
